import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Usando o arquivo CSS que já existe
import App from './App.jsx'; // Importando o componente App

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);